import { render, staticRenderFns } from "./talk.vue?vue&type=template&id=04c90531&scoped=true&"
import script from "./talk.vue?vue&type=script&lang=js&"
export * from "./talk.vue?vue&type=script&lang=js&"
import style0 from "./talk.vue?vue&type=style&index=0&id=04c90531&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c90531",
  null
  
)

export default component.exports